import { Fragment, useRef } from "react";
import { useTranslation } from "react-i18next";
import { View, Text, NativeSyntheticEvent, TextInputKeyPressEventData, StyleSheet } from "react-native";
import { FONT } from "../../../value/staticValues";
import { PAGE_URL } from "../../../value/Url";
import { CustomCancelBtn } from "../../base/CustomCancelBtn";
import { CustomConfirmBtn } from "../../base/CustomConfirmBtn";
import { InputTextUnderLine } from "../../base/CustomInputText";
import AlertContent from "../../base/tamplate/AlartContent";
import LoginBox from "../../base/tamplate/LoginBox";

import { ReactComponent as InfoImg } from "../../../img/ico-msg-info-white.svg";
import { ReactComponent as CloseImg } from "../../../img/ico-prefix-close-white.svg";

interface ResetPwdProps { 
    password:string;
    setPassword:(password:string)=>void;
    passwordCheck:string;
    setPasswordCheck:(password:string)=>void;
    infoText:string;
    infoError:boolean;
    sendChangePwdFn:()=>void;
    changePasswordYn: boolean;
}
export default function ResetPwd(props:ResetPwdProps) {
    const {t} = useTranslation();
    const newPwdInputRef = useRef<HTMLInputElement>(null);
    const newPwdCheckInputRef = useRef<HTMLInputElement>(null);

    return (
        <LoginBox>
            <View style={{
                flexDirection:"row", alignItems: "center", justifyContent: "center",
                marginTop: 60,
            }}>
                <View style={{
                    width: 300, marginBottom: "auto"
                }}>
                    <View style={{flexDirection: "row", alignItems: "center"}}>
                        <Text style={{
                            fontFamily: FONT.MEDIUM,
                            fontSize: 24,
                            lineHeight: 36,
                            letterSpacing: -0.16,
                            color: "#333"
                        }}>
                            {t("CHANGE_PWD_TEXT")}
                        </Text>
                    </View>
                    <View style={{flexDirection: "row", marginTop: 27, width: 280}}>
                        <Text style={styles.Text}>
                            {t("CHANGE_PWD_START_INFO_TEXT")}&nbsp;
                            <Text style={{...styles.Text, color: "#db4d30"}}>
                                {t("CHANGE_PWD_RED_INFO_TEXT")}&nbsp;
                            </Text>
                            <Text style={styles.Text}>
                                {t("CHANGE_PWD_END_INFO_TEXT")}
                            </Text>
                        </Text>
                    </View>

                </View>

                <View style={{
                    width: 360,
                    marginLeft: 60
                }}>
                    <InputTextUnderLine
                        text={t("NEW_PWD_TEXT")}
                        inputref={newPwdInputRef}
                        inputprops={{
                            secureTextEntry: true,
                            placeholder: t("NEW_PWD_TEXT"),
                            onChangeText: (Text:string) => props.setPassword(Text.trim()),
                            onKeyPress: (event:NativeSyntheticEvent<TextInputKeyPressEventData>) => {
                                if(event.nativeEvent.key === "Enter") {
                                    newPwdCheckInputRef.current?.focus();       
                                }
                            }
                        }}
                    />

                    <InputTextUnderLine
                        text={t("NEW_PWD_CHECK_TEXT")}
                        inputref={newPwdCheckInputRef}
                        inputprops={{
                            secureTextEntry: true,
                            placeholder: t("NEW_PWD_CHECK_TEXT"),
                            onChangeText: (Text:string) => props.setPasswordCheck(Text.trim()),
                            onKeyPress: (event:NativeSyntheticEvent<TextInputKeyPressEventData>) => {
                                if(event.nativeEvent.key === "Enter") {
                                    props.sendChangePwdFn()
                                }
                            }
                        }}
                    />

                    <View style={{
                        marginTop: 33
                    }}>
                        <AlertContent
                            size={33}
                            text={props.infoText}
                            error={props.infoError}
                        />
                    </View>
                    

                    <View style={{flexDirection: "row", alignItems: "center", marginTop: 16}}>
                        <CustomConfirmBtn
                            size={{width: 250, height: 52}}
                            fontsize={12}
                            disabled={props.changePasswordYn}
                            text={t("CHANGE_PWD_TEXT")}
                            onPress={() => {
                                props.sendChangePwdFn()
                            }}
                        />
                    </View>
                </View>
            </View>
        </LoginBox>
    )
}


const styles = StyleSheet.create({
    Text: {
        fontFamily: FONT.REGULAR,
        fontSize: 14,
        lineHeight: 20,
        color: "#8c9299"
    }
})